import { i18next } from '@packlink/translation-provider';

export const getBackendLocale = (): string => i18next.language.replace('-', '_');

/**
 * Get locale from pathname
 * paypal.packlink.com/es/nl-NL
 * Will pick nl-NL
 */
export const getLocaleFromPathname = (): string => window.location.pathname.split('/')[2];
